module.exports = __webpack_public_path__ + "static/pabbly-connect-b7eb4b840b02037fff897f367fda9ac8.svg";